import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';

import dashboard from './layouts/dashboard.vue';
import login from './pages/login.vue';
import index from './pages/index.vue';
import delivery from './pages/delivery.vue';
import pickup from './pages/pickup.vue';
import order from './pages/order.vue';
import history from './pages/history.vue';
import canceled from './pages/canceled.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'loginNoUid',
    component: login,
  },
  {
    path: '/login/:uid',
    name: 'login',
    component: login,
  },
  {
    path: '/',
    component: dashboard,
    children: [
      {
        path: '/',
        name: 'index',
        component: index
      },
      {
        path: '/order',
        name: 'order',
        component: order,
        props: true
      },
      {
        path: '/delivery',
        name: 'delivery',
        component: delivery
      },
      {
        path: '/pickup',
        name: 'pickup',
        component: pickup
      },
      {
        path: '/history',
        name: 'history',
        component: history
      },
      {
        path: '/canceled',
        name: 'canceled',
        component: canceled
      },
    ]
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const sessionEnabled = store.state.session != null;

  if (to.name === 'login' || to.name === 'loginNoUid') {
    if (sessionEnabled) {
      next({ name: 'index' });
    } else {
      next();
    }
  } else if (sessionEnabled) {
    next();
  } else {
    next({ name: 'loginNoUid' });
  }
});

export default router;
